export const chartColors = [
  "#5f62f1",
  "#058194",
  "#76767f",
  "#9f41f6",
  "#917503",
  "#eb1414",
  "#53810e",
  "#e2187d",
] as const;

export const INACTIVE_CHART_COLOR_STRENGTH = 20;
export const CHART_TRANSITION_DURATION = "150ms";
